import React, { useState } from 'react'
import StepOtpVerification from './StepOtpVerification'
import StepPhoneInput from './StepPhoneInput'

export default function StepAccountVerification({ data, onBack, onNext }) {
  const [isOtpSection, setIsOtpSection] = useState(false)

  if (isOtpSection && data?.phone) {
    return <StepOtpVerification data={data} onBack={onBack} onNext={onNext} />
  }

  return (
    <StepPhoneInput
      data={data}
      onNext={(data) => {
        onNext(data, false)
        setIsOtpSection(true)
      }}
      onBack={onBack}
    />
  )
}
